// @flow

import {TABS_KEYS} from './tabs-names';
import {MENU_ITEMS_KEYS} from 'app-my-navigation/js/types';


// 'KEY' depending on route to recognize current route by key for concrete tab;
// 'MenuKey' Navigation Menu has own numeration ids ();

// If we didn't get some items from Menu then we need to hide in tabs (every userrole has different advantages)


//strict order according to UI behaviour
const TABS_DATA_BY_MENU_KEY = {
	[MENU_ITEMS_KEYS.DMS.DMS_POLICY]: {
		key: TABS_KEYS.POLICY,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_INSURANCE_PROGRAMS]: {
		key: TABS_KEYS.PROGRAM_INSURANCE,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_MEDICAL_TYPES]: {
		key: TABS_KEYS.MEDICAL_TYPES,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_LPU]: {
		key: TABS_KEYS.MEDICAL_OFFICES,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_SEND_REQUEST]: {
		key: TABS_KEYS.SEND_REQUEST,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_NOTIFICATION]: {
		key: TABS_KEYS.NOTIFICATIONS,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_SERVICES]: {
		key: TABS_KEYS.SERVICES,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_FRANCHISE]: {
		key: TABS_KEYS.FRANCHISE,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_FAMILY_INSURANCE]: {
		key: TABS_KEYS.FAMILY_INSURANCE,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_UPGRADE_PROGRAM]: {
		key: TABS_KEYS.UPGRADE_PROGRAM,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_MEDICAL_CARE]: {
		key: TABS_KEYS.MEDICAL_CARE,
	},
	[MENU_ITEMS_KEYS.DMS.DMS_TELEMEDICINE]: {
		key: TABS_KEYS.TELEMEDICINE,
	},
};


const ModuleNames = {
	MAIN: 'main',
};


export const GENDER_TEXT = {
	Male: 'Мужской',
	Female: 'Женский',
};

export const IDENTITY_DOCUMENT_TYPE_TEXT = {
	RussianPassport: 'Паспорт гражданина РФ',
	ForeignPassport: 'Иностранный паспорт',
};

// eslint-disable-next-line no-useless-escape
export const TEST_POLICY_NUMBER = 'АО \"Личный кабинет\"-00001'; //this for blocking Buy btn in Requests tab for Test Contract

export const NEW_MA_ATTENTION_TEXT = {
	// eslint-disable-next-line max-len
	text: 'К сожалению, Ваше приложение РГС ДМС устарело. В новой версии приложения доступны новые функции. Предлагаем Вам настроить новую версию РГС ДМС на Вашем смартфоне.',
	url: 'https://www.rgs.ru/app',
	text2: 'Текущая версия более не поддерживается. Её можно удалить.',
};

/*eslint-disable max-len*/
export const BLOCKER_DATA = {
	desktopImage: 'https://old.rgs.ru/upload/medialibrary/75f/720x400_3_zadolzhnost.jpg',
	mobileImage: 'https://old.rgs.ru/upload/medialibrary/930/600x320_3_zadolzhnost.jpg',
	title: 'Доступ в клиники заблокирован! Вам доступна только организация экстренной медицинской помощи!',
	text: '<p>Обслуживание по полису ДМС приостановлено, так как у Вас имеется задолженность по оплате франшизы.</p>Для организации экстренной помощи обратитесь в Федеральный медицинский контактный центр ПАО СК «Росгосстрах»:<p></p>',
	textSecond: '<p>Для восстановления обслуживания погасите задолженность  по оплате франшизы.  Для этого,  выберите полис ДМС  с задолженностью и перейдите в раздел «Франшиза» или нажмите на кнопку «Перейти».</p>',
	actionText: 'Перейти',
	phones: [
		{Number: '8 800 200-51-11', AdditionalNumber: null, Type: '', IsConfirmed: false, PhoneType: null},
	],
};

export const SEND_AGREEMENT_STATUSES = {
	success: 'Success',
};

export const KID_DATA = {
	label: 'С положениями Ключевого информационного документа (КИД) об условиях договора ознакомлен(-а), КИД получил(-а), согласен(-на) с возможными расхождениями между КИД и Договором и принимаю окончательные условия, изложенные в Договоре',
};

export const KID_STATUSES = {
	none: 'None',
	agreed: 'Agreed',
	notAgreed: 'NotAgreed',
};

export const CSS_CLASSES = {
	noScrollDesktop: 'disable-body-scroll',
	noScrollAny: 'disable-any-body-scroll',
	noScrollMobile: 'disable-mobile-body-scroll',
	noScrollHtml: 'disable-html-scroll',
	noScrollHtmlMobile: 'disable-html-only-mobile-scroll',
	frameHeightMobileClinics: 'frame-height-mobile-clinics',
};

const DmsEventEmitter = {
	Name: 'rgsAppDmsInsuranceEventEmitter',
};

export const PERSONAL_AGREEMENT = 'https://www.rgs.ru/about/soglasiya-lk-dms';

//exporting at the one point
export {
	TABS_DATA_BY_MENU_KEY,
	ModuleNames,
	DmsEventEmitter,
};
